import { charts } from './cloudTemplates/cloud.graph.config';
import rdsMySqlCharts from './cloudTemplates/aws/rds.mysql.config.js';
import lambdaCharts from './cloudTemplates/aws/lambda.config.js';
import elastiCacheCharts from './cloudTemplates/aws/elasticache.config';
import ingressCharts from './cloudTemplates/aws/ingress.config.js';
import i18n from '@/plugins/i18n';

export const getGkeNavTabs = () => [
  {
    key: 'nodes',
    label: i18n.global.t('k8.nodesCap'),
  },
  {
    key: 'pods',
    label: i18n.global.t('k8.pod'),
  },
  {
    key: 'containers',
    label: i18n.global.t('containers'),
  },
];

const cloudTemplate = {
  GKE: {
    navItems: getGkeNavTabs(),
    NODES: {
      infoBox: [
        {
          label: i18n.global.t('total-node'),
          value: 0,
          color: '#f59600',
        },
        {
          label: i18n.global.t('total-cores'),
          value: 0,
          color: '#f59600',
        },
        {
          label: i18n.global.t('avg-memory-usage'),
          value: 0,
          color: '#f59600',
        },
        {
          label: i18n.global.t('avg-allocable-memory'),
          value: 0,
          color: '#f59600',
        },
        {
          label: i18n.global.t('free-inodes'),
          value: 0,
          color: '#f59600',
        },
        {
          label: i18n.global.t('pid-usage'),
          value: 0,
          color: '#f59600',
        },
      ],
      charts,
    },
  },
  AWS: {
    RDS: {
      overview: {
        cards: {
          template: rdsMySqlCharts().cardComponents,
        },
        table: {
          show: true,
          width: '98%',
        },
      },
      subscriptionId: {
        cards: {
          template: rdsMySqlCharts().cardComponents,
        },
        graphs: {
          template: rdsMySqlCharts().lineChartsSubscriptionPage,
        },
        table: {
          show: true,
          width: '98%',
        },
      },
      databases: {
        graphs: {
          template: rdsMySqlCharts().lineChartsDatabasePage,
        },
      },
    },
    LAMBDA: {
      overview: {
        graphs: {
          template: lambdaCharts().lineChartsOverviewPage,
        },
      },
      subscriptionId: {
        graphs: {
          template: lambdaCharts().lineChartsSubscriptionPage,
        },
      },
      functions: {
        table: {
          show: true,
          width: '98%',
        },
      },
    },
    ELASTICACHE: {
      overview: {
        graphs: {
          template: elastiCacheCharts().lineChartsOverviewPage,
        },
      },
      subscriptionId: {
        navItems: [
          {
            key: 'Host',
            label: 'Host',
            template: elastiCacheCharts().host,
          },
          {
            key: 'Redis',
            label: 'Redis',
            template: elastiCacheCharts().redis,
          },
          {
            key: 'Memcached',
            label: 'Memcached',
            template: elastiCacheCharts().memcached,
          },
        ],
      },
    },
    INGRESS: {
      overview: {
        graphs: {
          template: ingressCharts().lineChartsOverviewPage,
        },
      },
      subscriptionId: {
        navItems: [
          {
            key: 'ALB',
            label: 'ALB',
            template: ingressCharts().lineChartsALB,
          },
          {
            key: 'NLB',
            label: 'NLB',
            template: ingressCharts().lineChartsNLB,
          },
          {
            key: 'CLB',
            label: 'CLB',
            template: ingressCharts().lineChartsCLB,
          },
        ],
      },
    },
  },
};

export default cloudTemplate;
